import { useMemo } from 'react'
import classnames from 'classnames/bind'
import moment from 'moment'
import { useTranslation } from 'next-i18next'

// Methods
import { prepareArticleHtml } from '../../methods'

// Types
import type { FetchHelpArticleResponse } from '@/api/fetchHelpArticle'

// Styles
import styles from '../../style.module.scss'

const cx = classnames.bind(styles)

/** 條款類文件（/terms/*）：內容來自幫助中心固定頁面，版面不放搜尋、評價、相關文章 */
const LegalDocument = ({ article }: { article: FetchHelpArticleResponse }) => {
  const { t } = useTranslation()
  const { html, toc } = useMemo(() => prepareArticleHtml(article.content), [article.content])
  const showToc = article.showToc && toc.length > 1

  return (
    <div className={cx('help', 'help--legal')}>
      <main className={cx('help__body')}>
        <div className={cx('help-article-layout', { 'help-article-layout--with-toc': showToc })}>
          <article className={cx('help-card', 'help-article')}>
            <h1 className={cx('help-article__title')}>{article.title}</h1>
            <p className={cx('help-article__updated')}>{t('Help_Center_Updated_At', { date: moment(article.updatedAt).format('YYYY/MM/DD') })}</p>
            {showToc && (
              <nav className={cx('help-toc', 'help-toc--inline')} aria-label={t('Help_Center_Toc')}>
                <p className={cx('help-toc__title')}>{t('Help_Center_Toc')}</p>
                <ol>
                  {toc.map((item) => (
                    <li key={item.id}>
                      <a href={`#${item.id}`}>{item.text}</a>
                    </li>
                  ))}
                </ol>
              </nav>
            )}
            <div className={cx('help-article__content')} dangerouslySetInnerHTML={{ __html: html }} />
          </article>
          {showToc && (
            <aside className={cx('help-article-layout__aside')}>
              <nav className={cx('help-toc', 'help-toc--aside')} aria-label={t('Help_Center_Toc')}>
                <p className={cx('help-toc__title')}>{t('Help_Center_Toc')}</p>
                <ol>
                  {toc.map((item) => (
                    <li key={item.id}>
                      <a href={`#${item.id}`}>{item.text}</a>
                    </li>
                  ))}
                </ol>
              </nav>
            </aside>
          )}
        </div>
      </main>
    </div>
  )
}

export default LegalDocument
